
export default {
  methods: {
    labelForProductUnit(unit) {
      switch (unit) {
        case 'cubicFeet':
          return 'cubic ft.';
        case 'cubicYard':
          return 'cubic yd.';
        case 'lb':
          return 'lb';
        case 'ton':
          return 'ton';
        default:
          return '';
      }
    },
  },
};
